import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ShellDomainProvider } from '../../../shared/standalone-packages/ecap3/core';

@Component({
    selector: 'app-about-dialog',
    templateUrl: 'about-dialog.component.html',
    styleUrls: ['about-dialog.component.scss'],
    standalone: false
})
export class AboutDialogComponent implements OnInit {
    fullYear: number;
    termsCondition1: any;
    termsCondition2: any;
    termsCondition3: any;
    siteLogo: string = ShellDomainProvider['api']['SiteLogo'];
    version: string = ShellDomainProvider['api']['Version'];

    constructor(
        public dialogRef: MatDialogRef<AboutDialogComponent>,
        private _DomSanitizer: DomSanitizer
    ) {
        if (ShellDomainProvider['api']['TermsCondition1']) {
            this.termsCondition1 = ShellDomainProvider['api']['TermsCondition1'];
        }

        if (ShellDomainProvider['api']['TermsCondition2']) {
            this.termsCondition2 = ShellDomainProvider['api']['TermsCondition2'];
        }

        if (ShellDomainProvider['api']['TermsCondition3']) {
            this.termsCondition3 = ShellDomainProvider['api']['TermsCondition3'];
        }
    }

    close(): void {
        this.dialogRef.close();
    }
    ngOnInit() {
        this.footerDate();
    }

    public footerDate(): void {
        const date = new Date();
        this.fullYear = date.getFullYear();
    }
}
